import { useHistory } from "react-router-dom";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : MenuItems
Description : Componente que contiene la información de los botones de la barra de navegación de la aplicación
Date Autor Modification
================================================================================
30/09/2021 Santiago Coca Rojas Creación – Se defienen los botones de la barra de navegación.
================================================================================ */
export default function MenuItems3() {
    let history = useHistory();
    const items = [
        {
            label: 'Novedades',
            path: "/Novelties",
            index: 0,
        },
        {
            label: 'Nómina',
            path: "/Process",
            index: 1,
        },
        {
            label: 'Seguridad social',
            path: "/SocialSecurity",
            index: 2,
        },
        {
            label: 'Contabilidad',
            path: "/Accounting",
            index: 3,
        },
        {
            label: 'Consignación cesantías',
            path: "/Severance",
            index: 4,
        },
        {
            label: 'Ingresos y retenciones',
            path: "/CIR_Payroll",
            index: 5,
        },
        {
            label: 'Nómina electrónica',
            path: "/ElectronicPayroll",
            index: 6,
        }
    ]
    return items
}